export const computeInternalId = ({
  id,
  claimId,
  uniquenessByProduct,
}: {
  id: string;
  claimId?: string;
  uniquenessByProduct: boolean;
}) => (uniquenessByProduct ? `${id}_${claimId}` : id);
